import { Button, DrawerStepper, Text } from '@mercai/clever'
import { useEffect, useState } from 'react'

import { SelectSaleOrdersForm } from '@/components'
import { SaleOrderProps } from '@/types'
import { useTranslation } from 'react-i18next'
import { DrawerSaleOrdersProps } from './drawer-sale-orders.type'

import styles from './drawer-sale-orders.module.css'

export const DrawerSaleOrders = ({
  isOpen,
  onClose,
  saleOrders,
  setSaleOrders,
  supplierUuid,
}: DrawerSaleOrdersProps) => {
  const { t } = useTranslation('screenSupplierOrderManagementComponents')

  const filters = {
    shipments_Supplier_Uuid: supplierUuid || '',
    hasPendingSupplyOrder: 'true',
    hasInventoryTransaction: 'true',
  }

  const [selectedSaleOrdersValues, setSelectedSaleOrdersValues] = useState<
    SaleOrderProps[]
  >([])

  const handleClose = () => {
    onClose()
  }

  const onHandleSubmitSelectSaleOrders = () => {
    setSaleOrders(selectedSaleOrdersValues || [])

    handleClose()
  }

  useEffect(() => {
    setSelectedSaleOrdersValues(saleOrders || [])
  }, [saleOrders])

  return (
    <DrawerStepper
      isOpen={isOpen}
      onHandleOpen={handleClose}
      initialStep="root"
      translations={{ optional: '' }}
      title={t('componentDrawerSaleOrdersTitle')}
      description={t('componentDrawerSaleOrdersDescription')}
      steps={{
        root: {
          backNavigate: 'root',
          isOptional: false,
          component: () => (
            <div>
              <div className={styles['new-sale-orders-box']}>
                <Text variant="title-medium">
                  {t('componentDrawerSaleOrdersSelectSaleOrdersTitle')}
                </Text>
              </div>
              <SelectSaleOrdersForm
                filters={filters}
                values={selectedSaleOrdersValues}
                onChangeValues={setSelectedSaleOrdersValues}
                errors={{}}
              />
            </div>
          ),
          footer: (
            <div className={styles.footer}>
              <Button variant="secondary" onClick={handleClose}>
                {t('cancelButton')}
              </Button>
              <Button
                variant="primary"
                onClick={onHandleSubmitSelectSaleOrders}
              >
                {t('confirmButton')}
              </Button>
            </div>
          ),
        },
      }}
    />
  )
}
